import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import { requestInlines } from "actions/adActions";
import SnippetAdContainer from 'components/ads/inline';
import { translatable } from "services/Intl";


function SeoSnippetAdContainer({ adInline, requestInlinesAction, search, t }) {
  if (!adInline) return null;

  return (
    <SnippetAdContainer
      key={ adInline.id }
      ad={ adInline }
      data={ search }
      handleClick={ () => requestInlinesAction(search) }
      isSerp={ false }
      position={ 1 }
      t={ t }
    />
  );
}

SeoSnippetAdContainer.defaultProps = {
  adInline: null,
  search: null,
};

SeoSnippetAdContainer.propTypes = {
  adInline: PropTypes.shape({
    clickout: PropTypes.string,
    color: PropTypes.string,
    id: PropTypes.string,
    image: PropTypes.string,
    logo: PropTypes.string,
    transactionId: PropTypes.string,
  }),
  requestInlinesAction: PropTypes.func.isRequired,
  search: PropTypes.shape(),
  t: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  adInline: state.adsReducer.inlines[0],
  search: state.destination,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  requestInlinesAction: requestInlines,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(translatable(SeoSnippetAdContainer));
